import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { media } from '../../services/media';

import { themeStyles } from '../../services/themeStyles';

const Pengestyrke = themeStyles(
    'pengestyrke',
    css`
        max-width: 1200px;
    `,
);

const Formue = themeStyles(
    'formue',
    css`
        max-width: 1440px;
    `,
);

export const Container = styled.div`
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

    ${media.max('lg')} {
        flex-wrap: wrap;
    }

    ${Pengestyrke}
    ${Formue}
`;
